import { ReactNode, ReactElement } from 'react';
import { OidcProvider } from '@axa-fr/react-oidc';
import { isEmpty } from 'lodash-es';

import { ReLoginDialog } from './ReLoginDialog';

import { useThrowError } from '../utils/useThrowError';
import { oidcConfiguration } from '../oidcConfigurations';
import { useOpenReLoginDialog } from '../services/store/OpenReLoginDialog';

import {
  getSsAuthValidateRetryCount,
  setSsAuthValidateRetryCount,
} from '../utils/sessionStorageService';

import { PAGE_PATH, PARAM_NAME } from '../constants';
import {
  AUTH_VALIDATION_RETRY_COUNT_NUM,
  OIDC_EVENT_NAME,
} from '../constants/system';

/**
 * OidcProvider
 * 他のタブでログアウトした時の処理を書いています
 */
export function CustomOidcProvider({
  children,
}: {
  children: ReactNode;
}): ReactElement {
  const { setOpen } = useOpenReLoginDialog();
  const { throwError } = useThrowError();

  /**
   * @TODO 後ほどリファクタリングする
   * @TODO エラーハンドリングを実装する
   **/
  const url = new URL(window.location.href);
  const params = url.searchParams;

  // 他システムから渡されるパラメータを取得
  const system = params.get(PARAM_NAME.SYSTEM);
  const loginId = params.get(PARAM_NAME.LOGIN_ID);
  const oneTimeId = params.get(PARAM_NAME.ONE_TIME_ID);
  const redirectPage = params.get(PARAM_NAME.REDIRECT_PAGE);

  if (
    !isEmpty(system) &&
    !isEmpty(loginId) &&
    !isEmpty(oneTimeId) &&
    !isEmpty(redirectPage)
  ) {
    // 他システムから渡されるパラメータをSessionStorageに保存
    sessionStorage.setItem(PARAM_NAME.SYSTEM, system as string);
    sessionStorage.setItem(PARAM_NAME.LOGIN_ID, loginId as string);
    sessionStorage.setItem(PARAM_NAME.ONE_TIME_ID, oneTimeId as string);
    sessionStorage.setItem(PARAM_NAME.REDIRECT_PAGE, redirectPage as string);

    // 他システムから渡されるパラメータをOIDC設定に追加
    oidcConfiguration.extras = {
      system: `${system}`,
      loginId: `${loginId}`,
      oneTimeId: `${oneTimeId}`,
      redirectPage: `${redirectPage}`,
      prompt: `login`,
    };
  }

  return (
    <>
      <OidcProvider
        configuration={oidcConfiguration}
        onLogoutFromAnotherTab={() => setOpen(true)}
        onSessionLost={() => setOpen(true)}
        onEvent={(_, name) => {
          if (name === OIDC_EVENT_NAME.LOGIN_CALLBACK_ASYNC_ERROR) {
            const authValidationRetryCount = getSsAuthValidateRetryCount();
            setSsAuthValidateRetryCount(authValidationRetryCount + 1);

            if (authValidationRetryCount < AUTH_VALIDATION_RETRY_COUNT_NUM) {
              window.location.replace(PAGE_PATH.ROOT);
            } else {
              setSsAuthValidateRetryCount(0);
              throwError(OIDC_EVENT_NAME.LOGIN_CALLBACK_ASYNC_ERROR);
            }
          } else if (
            name === OIDC_EVENT_NAME.TRY_KEEP_EXISTING_SESSION_ASYNC_END
          ) {
            setSsAuthValidateRetryCount(0);
          }
        }}
      >
        {children}
      </OidcProvider>
      <ReLoginDialog />
    </>
  );
}
